import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { CryptoTopUpStep } from "@src/widgets/onboarding/classes/tours/AccountTopUpTour/steps/CryptoTopUpStep"
import { FiatBalanceTopUpStep } from "@src/widgets/onboarding/classes/tours/AccountTopUpTour/steps/FiatBalanceTopUpStep"
import { TopUpStep } from "@src/widgets/onboarding/classes/tours/AccountTopUpTour/steps/TopUpStep"
import { WithdrawalInCryptocurrencyStep } from "@src/widgets/onboarding/classes/tours/AccountTopUpTour/steps/WithdrawalInCryptocurrencyStep"
import { WithdrawalInCryptoCurrencyWhiteListStep } from "@src/widgets/onboarding/classes/tours/AccountTopUpTour/steps/WithdrawalInCryptoCurrencyWhiteListStep"
import { WithdrawalInFiatCurrencyBankDetailsStep } from "@src/widgets/onboarding/classes/tours/AccountTopUpTour/steps/WithdrawalInFiatCurrencyBankDetailsStep"
import { WithdrawalInFiatCurrencyStepSubmit } from "@src/widgets/onboarding/classes/tours/AccountTopUpTour/steps/WithdrawalInFiatCurrencyStepSubmit"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class AccountTopUpTour extends BaseTour {
  name = ONBOARDING_TOURS.ACCOUNT_TOP_UP

  steps = [
    new TopUpStep(),
    new CryptoTopUpStep(),
    new FiatBalanceTopUpStep(),
    new WithdrawalInCryptoCurrencyWhiteListStep(),
    new WithdrawalInCryptocurrencyStep(),
    new WithdrawalInFiatCurrencyBankDetailsStep(),
    new WithdrawalInFiatCurrencyStepSubmit(),
  ]
}
